import React, { useState } from "react";
import { Box } from "@mui/system";
import { Paper, Button } from "@mui/material";
import { IconButton } from "@mui/material";
import { InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function TransactionBar(props) {
  return (
    <Box sx={{ width: "100%", flexGrow: 1, height: "30%", marginTop: "8px" }}>
      <Box>
        <Paper
          component="form"
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              // width: "232.68px",
              height: "50px",
              width: "189px",
              fontWeight: "bold",
              color: "black",
              textAlign: "center",
              display: "flex",
              // alignItems:"center",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#E0E0E0",
              font: "Inter",
              Weight: "600, Semi Bold",
              size: "16px",
            }}
          >
           {props?.text}
          </Paper>
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search"
            inputProps={{ "aria-label": "search" }}
          />
          <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
            <SearchIcon />
          </IconButton>
        </Paper>
      </Box>
    </Box>
  );
}
